import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import Markdown from "src/components/Markdown";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";

/**
 * Event list component that displays events in a two-column layout
 * with title/description on the left and guarantee pill on the right
 */
const TournamentEventList = ({ events = [] }) => {
  if (!Array.isArray(events) || events.length === 0) return null;

  return (
    <>
      {events.map((event, index) => (
        <Row key={`event-${index}`} className="mb-4">
          <Col md={8}>
            <SubTitleSection
              subTitle={event.title}
              text={event.description}
              as="h4"
              dark={true}
              variant="compact"
              subtitleColor="var(--red)"
              className="py-0"
            />
          </Col>
          {event.guarantee && (
            <Col md={4}>
              <EventGuarantee>
                <Markdown>{event.guarantee}</Markdown>
              </EventGuarantee>
            </Col>
          )}
        </Row>
      ))}
    </>
  );
};

const EventGuarantee = styled.div`
  margin-top: 5px;

  p {
    margin: 0 !important;
    display: block;
    width: 100%;
    background: linear-gradient(
      180deg,
      rgba(245, 24, 24, 0.368) 0%,
      rgba(236, 32, 32, 0.35) 100%
    );
    color: #fff;
    font-size: 0.95rem;
    line-height: 1.15;
    padding: 0.5rem 0.75rem;
    border-radius: 5px;
    letter-spacing: 0.01em;
    text-align: center;
    box-shadow: inset 0 0 0 1px rgba(255, 78, 78, 0.45);
  }

  @media (max-width: 768px) {
    p {
      width: auto;
      display: inline-block;
      min-width: 14rem;
      font-size: inherit;
    }
  }
`;

export default TournamentEventList;
